import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from '../../../context/LoadingContext';
import BuyerLanguageRegion from "./LanguageRegion";
import BuyerNotification from "./Notification";
import BuyerPolicySecurity from "./PolicySecurity";
import BuyerKYC from "./KycVerification";
import BankAccount from "./BankAccount";
import KYBVerification from "./KYBVerification";
const BuyerSetting = () => {
    const [activeUser, setActiveUser] = useState("");
    const [activeTab, setActiveTab] = useState("KYB Verification");
    const { setLoading } = useLoading();
    const navigate = useNavigate();

    const tabs = [ "KYB Verification", "KYC Verification", "Language & Region", "Notifications", "Privacy & Security"];
    const renderTabContent = () => {
        switch (activeTab) {
            case "KYB Verification":
                return <KYBVerification />;
            case "Language & Region":
                return <BuyerLanguageRegion />;
            case "Notifications":
                return <BuyerNotification />;
            case "Privacy & Security":
                return <BuyerPolicySecurity />;
            case "KYC Verification":
                return <BuyerKYC />;
            // case "Bank Accounts":
            //      return <BankAccount />;

            default:
                <KYBVerification />
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab
                                        ? "active"
                                        : "notactive"
                                        }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default BuyerSetting;